import React, { Component } from "react";
import { connect } from "react-redux";
import { updateTutorial, deleteTutorial } from "../actions/tutorials";
import TutorialDataService from "../services/tutorial.service";

// class based components are no fun, look at all the bind(this)
// the state is very similar to add tutorial but does not have a submitted
// instead has a message
class Tutorial extends Component {
  constructor(props) {
    super(props);
    this.onChangeTitle = this.onChangeTitle.bind(this);
    this.onChangeDescription = this.onChangeDescription.bind(this);
    this.onChangeAuthor = this.onChangeAuthor.bind(this);
    this.getTutorial = this.getTutorial.bind(this);
    this.updateStatus = this.updateStatus.bind(this);
    this.updateContent = this.updateContent.bind(this);
    this.removeTutorial = this.removeTutorial.bind(this);

    this.state = {
      currentTutorial: {
        id: null,
        title: "",
        description: "",
        author: "",
        published: false,
      },
      message: "",
    };
  }

  // this would be refactored out in hooks, not sure how specifically
  // for now we require the passed props to match the id of the tutorial
  componentDidMount() {
    this.getTutorial(this.props.match.params.id);
  }

  // notice how repetitive these 3 methods are?
  // all we do is spread in previous state and then
  // take input value and set it to a single field name
  //
  // DRYer how?
  // my guess would be something like my previous form input code
  // [key]: value....
  // note also ({}) is ~ return {}
  onChangeTitle(e) {
    const title = e.target.value;
    this.setState((prevState) => ({
      currentTutorial: {
        ...prevState.currentTutorial,
        title: title,
      },
    }));
  }
  onChangeDescription(e) {
    const description = e.target.value;
    this.setState((prevState) => ({
      currentTutorial: {
        ...prevState.currentTutorial,
        description: description,
      },
    }));
  }
  onChangeAuthor(e) {
    const author = e.target.value;
    this.setState((prevState) => ({
      currentTutorial: {
        ...prevState.currentTutorial,
        author: author,
      },
    }));
  }

  // we get the tutorial thus we have a .then and .catch
  // simply setting the currentTutorial state to the response
  getTutorial(id) {
    TutorialDataService.get(id)
      .then((response) => {
        this.setState({
          currentTutorial: response.data,
        });
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  }

  // update status takes the existing data and this components props
  // then updates via the id and the data, finally returning a
  // response and success message or catching and throwing an err
  updateStatus(status) {
    let data = {
      id: this.state.currentTutorial.id,
      title: this.state.currentTutorial.title,
      description: this.state.currentTutorial.description,
      author: this.state.currentTutorial.author,
      published: status,
    };
    this.props
      .updateTutorial(this.state.currentTutorial.id, data)
      .then((response) => {
        console.log(response);
        this.setState((prevState) => ({
          currentTutorial: {
            ...prevState.currentTutorial,
            published: status,
          },
        }));
        this.setState({ message: "The status was updated successfully!" });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  // update content is similar to updating status
  // instead of data we use this.state.currentTutorial
  // I suspect either this or the above function could be refactored
  // thus drying up code, but not a pressing issue.
  updateContent() {
    this.props
      .updateTutorial(this.state.currentTutorial.id, this.state.currentTutorial)
      .then((response) => {
        console.log(response);
        this.setState({ message: "The tutorial was updated successfully!" });
      })
      .catch((e) => {
        console.log(e);
      });
  }

  // remove simply needs the id and uses history, I presume this
  // connect-history-api-fallback@^1.6.0, history.push("/tutorials")
  // implies that a new version of the tutorials list is added to
  // history, thus allowing for future time travel, which redux is
  // known for, I do not see time travel used anywhere yet.
  removeTutorial() {
    this.props
      .deleteTutorial(this.state.currentTutorial.id)
      .then(() => {
        this.props.history.push("/tutorials");
      })
      .catch((e) => {
        console.log(e);
      });
  }

  // render needs a current tutorial to be added to state
  // then returns our tutorial adding form with the data
  // already populated but easily changed via buttons and handlers.
  render() {
    const { currentTutorial } = this.state;

    return (
      <div>
        {currentTutorial ? (
          <div className="edit-form">
            <h4>Tutorial</h4>
            {/* edit a tutorial to see this form with data */}
            <form>
              <div className="form-group">
                <label htmlFor="title">Title</label>
                <input
                  type="text"
                  className="form-control"
                  id="title"
                  value={currentTutorial.title}
                  onChange={this.onChangeTitle}
                />
              </div>
              <div className="form-group">
                <label htmlFor="description">Description</label>
                <input
                  type="text"
                  className="form-control"
                  id="description"
                  value={currentTutorial.description}
                  onChange={this.onChangeDescription}
                />
              </div>
              <div className="form-group">
                <label htmlFor="author">Author</label>
                <input
                  type="text"
                  className="form-control"
                  id="author"
                  value={currentTutorial.author}
                  onChange={this.onChangeAuthor}
                />
              </div>

              <div className="form-group">
                <label>
                  <strong>Status:</strong>
                </label>
                {currentTutorial.published ? "Published" : "Pending"}
              </div>
            </form>

            {/* button toggling published or unpublished */}
            {currentTutorial.published ? (
              <button
                className="badge badge-primary mr-2"
                onClick={() => this.updateStatus(false)}
              >
                UnPublish
              </button>
            ) : (
              <button
                className="badge badge-primary mr-2"
                onClick={() => this.updateStatus(true)}
              >
                {" "}
                Publish
              </button>
            )}

            <button
              className="badge badge-danger mr-2"
              onClick={this.removeTutorial}
            >
              Delete
            </button>
            <button
              type="submit"
              className="badge badge-success"
              onClick={this.updateContent}
            >
              Update
            </button>
            <p>{this.state.message}</p>
          </div>
        ) : (
          <div>
            {/* <br />
            <p>Click a Tutorial...</p> */}
          </div>
        )}
      </div>
    );
  }
}

export default connect(null, { updateTutorial, deleteTutorial })(Tutorial);
